import { createSelector } from 'reselect';

import { selectGetConfigValue } from '@pressreader/config';
import { ShareProvider } from '@pressreader/social-types';

export const selectShareEnabled = createSelector(
    selectGetConfigValue,
    getConfigValue =>
        getConfigValue<boolean>('ui.Sharing.enable', true) &&
        getConfigValue<{ id: string; enabled: boolean }[]>('UI.SharingMenu', []).some(s => s.enabled),
);

export const selectShareConfig = createSelector(selectGetConfigValue, getConfigValue => ({
    menu: getConfigValue<{ id: string; enabled: boolean }[]>('ui.SharingMenu', []).map(item => ({
        provider: item.id as ShareProvider,
        enabled: item.enabled,
    })),
}));
